var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Datepicker as DateField, Headline, Icon, } from '@folio/stripes/components';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { dateCompare, dateFromYYYYMMDD, minDate } from '../../utils/DateUtils';
import cssHiddenErrorField from './hiddenErrorField.css';
import css from './HoursAndExceptionFields.css';
import RowType from './RowType';
import TimeField from './TimeField';
export function updateRowState(rowStates, setRowStates, rowIndex, newState) {
    var newRowState = __spreadArray([], rowStates, true);
    newRowState[rowIndex] = __assign(__assign({}, newRowState[rowIndex]), newState);
    setRowStates(newRowState);
}
export function updateInnerRowState(rowStates, setRowStates, outerRowIndex, innerRowIndex, newState) {
    var newRowList = __spreadArray([], rowStates[outerRowIndex].rows, true);
    newRowList[innerRowIndex] = __assign(__assign({}, newRowList[innerRowIndex]), newState);
    updateRowState(rowStates, setRowStates, outerRowIndex, { rows: newRowList });
}
export function isInnerRowConflicted(error, outerRowI, innerRowI) {
    var _a, _b;
    return !!((_b = (_a = error === null || error === void 0 ? void 0 : error.intraConflicts) === null || _a === void 0 ? void 0 : _a[outerRowI]) === null || _b === void 0 ? void 0 : _b.has(innerRowI));
}
export function isOuterRowConflicted(error, outerRowI) {
    var _a;
    return !!((_a = error === null || error === void 0 ? void 0 : error.interConflicts) === null || _a === void 0 ? void 0 : _a.has(outerRowI));
}
export function getInnerRowError(isDirty, error, outerRowI, innerRowI, field) {
    var _a, _b, _c, _d, _f, _g;
    if (!isDirty)
        return undefined;
    return (((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.empty) === null || _a === void 0 ? void 0 : _a[field]) === null || _b === void 0 ? void 0 : _b[outerRowI]) === null || _c === void 0 ? void 0 : _c[innerRowI]) ||
        ((_g = (_f = (_d = error === null || error === void 0 ? void 0 : error.invalid) === null || _d === void 0 ? void 0 : _d[field]) === null || _f === void 0 ? void 0 : _f[outerRowI]) === null || _g === void 0 ? void 0 : _g[innerRowI]));
}
export function outerRowSorter(a, b) {
    // start date is enough for equality as overlap on the same day is disallowed
    var aMin = minDate(a.rows
        .filter(function (_a) {
        var startDate = _a.startDate;
        return startDate !== undefined;
    })
        .map(function (_a) {
        var startDate = _a.startDate;
        return dateFromYYYYMMDD(startDate);
    }));
    var bMin = minDate(b.rows
        .filter(function (_a) {
        var startDate = _a.startDate;
        return startDate !== undefined;
    })
        .map(function (_a) {
        var startDate = _a.startDate;
        return dateFromYYYYMMDD(startDate);
    }));
    return dateCompare(aMin, bMin);
}
export function getMainConflictError(error) {
    var _a;
    if (((_a = error === null || error === void 0 ? void 0 : error.interConflicts) === null || _a === void 0 ? void 0 : _a.size) !== undefined &&
        error.interConflicts.size > 0) {
        return (React.createElement(Headline, { margin: "none", className: css.conflictMessage, weight: "medium", size: "medium" },
            React.createElement(Icon, { icon: "exclamation-circle", status: "error" }),
            React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.exceptionConflictError" })));
    }
    return undefined;
}
export function getNameFieldError(touched, error, outerRowI) {
    var _a, _b;
    if (!touched)
        return undefined;
    return (_b = (_a = error === null || error === void 0 ? void 0 : error.empty) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b[outerRowI];
}
export function getDateField(key, row, innerRow, isDirty, _a, onChange) {
    var _b;
    var error = _a.error, fieldRefs = _a.fieldRefs, input = _a.input;
    return (React.createElement(DateField, { key: "".concat(key, "-").concat(innerRow.i), className: classNames((_b = {},
            _b[css.conflictCell] = isInnerRowConflicted(error, row.i, innerRow.i),
            _b), cssHiddenErrorField.hiddenErrorFieldWrapper), backendDateStandard: "YYYY-MM-DD", marginBottom0: true, placement: "auto", required: true, usePortal: true, value: innerRow[key], inputRef: function (el) {
            fieldRefs[key][row.i][innerRow.i] = el;
        }, error: getInnerRowError(isDirty, error, row.i, innerRow.i, 'startDate'), onBlur: function () { return input.onBlur(); }, onChange: function (_e, _formattedString, dateString) { return onChange(dateString); } }));
}
export function getDateTimeFields(_a) {
    var _b, _c;
    var props = _a.props, row = _a.row, innerRow = _a.innerRow, realIndex = _a.realIndex, innerRowRealIndex = _a.innerRowRealIndex, fieldRefs = _a.fieldRefs, isDirty = _a.isDirty, rowStates = _a.rowStates, setRowStates = _a.setRowStates;
    return {
        startDate: getDateField('startDate', row, innerRow, isDirty, props, function (dateString) {
            updateInnerRowState(rowStates, setRowStates, realIndex, innerRowRealIndex, { startDate: dateString });
            props.input.onBlur();
        }),
        startTime: (React.createElement(TimeField, { key: "st-".concat(innerRow.i), className: classNames((_b = {},
                _b[css.conflictCell] = isInnerRowConflicted(props.error, row.i, innerRow.i),
                _b)), display: row.type === RowType.Open, value: innerRow.startTime, inputRef: function (el) {
                fieldRefs.startTime[row.i][innerRow.i] = el;
            }, error: getInnerRowError(isDirty, props.error, row.i, innerRow.i, 'startTime'), onBlur: props.input.onBlur, onChange: function (newValue) {
                updateInnerRowState(rowStates, setRowStates, realIndex, innerRowRealIndex, { startTime: newValue });
            } })),
        endDate: getDateField('endDate', row, innerRow, isDirty, props, function (dateString) {
            updateInnerRowState(rowStates, setRowStates, realIndex, innerRowRealIndex, { endDate: dateString });
            props.input.onBlur();
        }),
        endTime: (React.createElement(TimeField, { key: "et-".concat(innerRow.i), className: classNames((_c = {},
                _c[css.conflictCell] = isInnerRowConflicted(props.error, row.i, innerRow.i),
                _c)), display: row.type === RowType.Open, value: innerRow.endTime, inputRef: function (el) {
                fieldRefs.endTime[row.i][innerRow.i] = el;
            }, error: getInnerRowError(isDirty, props.error, row.i, innerRow.i, 'endTime'), onBlur: props.input.onBlur, onChange: function (newValue) {
                updateInnerRowState(rowStates, setRowStates, realIndex, innerRowRealIndex, { endTime: newValue });
            } })),
    };
}
